
import { Component, Vue } from 'vue-property-decorator';
import FormHeader from '@/components/headers/form-header/form-header.vue';

import InputCC from '@/components/inputs/text/cc_number.input.vue';
import InputPark from '@/components/inputs/options/park.input.vue';
import InputClientType from '@/components/inputs/options/client-type.input.vue';
import { IPark } from '@/models/IPark.model';
import { UsersAPI } from '@/apis/users.api';

@Component({
  components: {
    'form-header': FormHeader,
    'input-cc': InputCC,
    'input-park': InputPark,
    'input-client-type': InputClientType
  },
  computed: {

    StoreParks: function () {
      return this.$store.state.parks;
    },

    StoreClientType: function () {
      return this.$store.state.clientType;
    }

  }
})
export default class Home extends Vue {

  private cc: string = '';

  private mounted() {
    const parkId = this.$route.params.parkId;
    const clientType = this.$route.params.clientType;

    if (parkId) this.$store.dispatch('setParkById', parkId)
    else this.$store.dispatch('fetchParks')

    if (clientType) this.$store.dispatch('setClientType', clientType)
    else this.$store.dispatch('setClientType', 'PUBLIC')


  }

  public async setCC($cc: string) {
    this.cc = $cc;
  }

  public async doSign() {
    if(this.$store.state.park && this.$store.state.park.name ){
      const cc = this.cc;
      const park = this.$store.state.park;
      const parkId = (park.name || '').replace(/[^A-Z0-9]+/ig, "_")
      const clientType = this.$store.state.clientType;
      const date = this.$store.state.time.date;
      const hour = this.$store.state.time.hour;
      const usersApi = new UsersAPI();
      const user = await usersApi.getByCC(cc);
        if (!user) {
          //const isReadt = await this.$store.dispatch('setUser', user);
          this.$router.push({ name: 'SignUpView', params: { cc: cc, park: parkId, clientType: clientType } });
        } else {
          const isReadt = await this.$store.dispatch('setUser', user);
          this.$router.push({ name: 'BookingView', params: { cc: cc, park: parkId, clientType: clientType } });
        }
      }
      else {
        this.$swal('ERROR', 'Seleccione un parque porfavor ', 'error')
      }
  }
}